export default "__VITE_ASSET__D3ykW8uE__";